import React from 'react'
import styled from '@emotion/styled'
import { colors, font, radius } from '@mobi/component-library/Theme/Common'
import { TicketStatus } from '@core/Areas/AccountActivity/types'

const enum LocalConstants {
  SizeLarge = 'js-last10--large',
}

export const Last10WinLossIndicator: React.FC<{
  size?: 's' | 'l'
  last10Results: (TicketStatus | 'Unknown')[]
}> = ({ size = 's', last10Results }) => {
  return (
    <WrapperStyled className={size === 'l' ? LocalConstants.SizeLarge : ''}>
      {last10Results.map((status, i) => {
        const isWin = status === 'Won'
        const isLoss = status === 'NoPayout'

        const className =
          (isWin && 'last10-indicator--win') || (isLoss && 'last10-indicator--loss') || ''

        return (
          <span key={i} className={`last10-indicator ${className}`}>
            {isWin ? 'W' : isLoss ? 'L' : '0'}
          </span>
        )
      })}
    </WrapperStyled>
  )
}

const WrapperStyled = styled.div({
  display: 'flex',
  justifyContent: 'space-between',

  '.last10-indicator': {
    flexShrink: 0,
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '2rem',
    height: '2rem',
    fontFamily: font.family.primary,
    fontWeight: font.weight.black,
    fontStyle: 'italic',
    borderRadius: radius.full,
    backgroundColor: '#DFDFDF',
    color: '#DFDFDF',

    '::after, ::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: radius.full,
    },

    '::after': {
      border: '1px solid transparent',
    },

    '::before': {
      boxShadow: '0 0.5px 2px 0.5px rgb(223, 222, 222) inset, 0 1px 0 0 rgba(255, 255, 255, 0.90)',
    },

    '&--win, &--loss': {
      textShadow: '0 0.5px 1px rgba(0, 0, 0, 0.25)',
    },

    '&--win': {
      backgroundColor: '#27BB36',
      color: colors.success[500],
      '::after': { borderColor: 'rgba(255, 255, 255, 0.18)' },
      '::before': {
        boxShadow: '0 1px 1px 0.5px #58AB62, 0 5px 5px 0 rgba(255, 255, 255, 0.50) inset',
      },
    },

    '&--loss': {
      backgroundColor: '#D9D9D9',
      color: colors.neutral[700],
      '::after': { borderColor: 'rgba(231, 231, 231, 0.40)' },
      '::before': {
        boxShadow:
          '0 1px 1.5px 0.5px rgba(0, 0, 0, 0.28), 0 5px 5px 0 rgba(255, 255, 255, 0.90) inset',
      },
    },
  },

  [`&.${LocalConstants.SizeLarge} .last10-indicator`]: {
    width: '2.6rem',
    height: '2.6rem',
  },
})
